<div [style.display]="!show ? 'none' : null" *ngIf="mode">
  <ion-toolbar>
    <ion-item id="title-item" slot="start" color="primary" lines="none">
      <ion-select
        [(ngModel)]="mode"
        (ionChange)="clearValidationErrors()"
        interface="popover"
        label="Vytvořit"
        labelPlacement="fixed"
      >
        <ion-select-option *ngFor="let mode of messageModes" [value]="mode">
          {{ mode.nameInDeclination }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-buttons slot="end">
      <ion-button (click)="hide()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-item *ngIf="validationErrors.size">
    <ion-text color="danger" *ngFor="let e of validationErrors; let isLast = last">
      {{ e }}{{ isLast ? '' : ',&nbsp;' }}
    </ion-text>
  </ion-item>

  <ion-item slot="start" [style.display]="!mode.hasRecipient ? 'none' : null">
    <ion-label position="fixed">
      Komu
      <ion-text color="danger">*</ion-text>
    </ion-label>

    <ionic-selectable
      #recipientSelect
      [(ngModel)]="msgRecipients"
      [items]="allowedRecipients"
      [canSearch]="true"
      [shouldFocusSearchbar]="true"
      (onSearch)="searchRecipient($event)"
    >
      <ng-template ionicSelectableItemTemplate let-recipient="item">
        {{ recipient?.title }}
      </ng-template>
      <ng-template ionicSelectableValueTemplate let-recipient="value">
        {{ recipient?.title }}
      </ng-template>

      <ng-template ionicSelectableHeaderTemplate>
        <ion-toolbar>
          <ion-buttons slot="primary">
            <ion-button (click)="onRecipientSelectClose()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title>Komu</ion-title>
        </ion-toolbar>
      </ng-template>

      <ng-template ionicSelectableCloseButtonTemplate>
        <ion-icon name="close" style="font-size: 24px"></ion-icon>
      </ng-template>
    </ionic-selectable>
  </ion-item>

  <ion-item slot="start" [style.display]="!mode.subjectAllowed ? 'none' : null">
    <ion-input [(ngModel)]="msgSubject" label="Předmět" labelPlacement="fixed">
      <ion-text color="danger" slot="label">*</ion-text>
    </ion-input>
  </ion-item>

  <ion-item [style.display]="!mode.attachmentAllowed ? 'none' : null">
    <ion-buttons slot="start" *ngIf="msgAttachmentName">
      <ion-button color="secondary" expand="block" fill="solid" (click)="clearFileInput()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <span slot="start" *ngIf="msgAttachmentName">
      <ion-icon name="attach-outline"></ion-icon>
      {{ msgAttachmentName }}
    </span>

    <ion-buttons slot="end">
      <ion-button color="secondary" expand="block" fill="solid" (click)="selectFile()">
        <ion-icon name="cloud-upload"></ion-icon>
        &nbsp;Nahrát přílohu
      </ion-button>
      <input type="file" #fileInput style="display: none" (change)="onFileInput()" />
    </ion-buttons>
  </ion-item>

  <ejs-richtexteditor
    class="rte"
    [toolbarSettings]="tools"
    [insertImageSettings]="rteInsertImageSettings"
    [(ngModel)]="msgBody"
  ></ejs-richtexteditor>
</div>
